import React from "react";
import { Modal, Form, Select } from "antd";

const AssignDiffUserModal = ({
  visible,
  onOk,
  onCancel,
  form,
  companyDiffUsers,
}) => (
  <Modal
    title="Assign Contract to Different User"
    open={visible}
    onOk={() => onOk("Contract to Different User")}
    onCancel={onCancel}
    okText="Send"
    okButtonProps={{
      style: {
        backgroundColor: "#4E36A3",
        color: "white",
        height: "40px",
        width: "100px",
      },
    }}
    cancelButtonProps={{
      style: {
        color: "#4E36A3",
        height: "40px",
        width: "100px",
      },
    }}
  >
    <Form form={form} initialValues={{ user_id: null }}>
      <Form.Item
        name="user_id"
        rules={[{ required: true, message: "Please select a user!" }]}
      >
        <Select
          options={companyDiffUsers
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((user) => ({
              value: user?.value,
              label: user?.label,
            }))}
        />
      </Form.Item>
    </Form>
  </Modal>
);

export default AssignDiffUserModal;
